import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";

class IrqVaLoanBeforeView extends Component {
  render() {
    const values = [false, true];
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/va_eligible.svg"
          />
          <IrqChoiceButtons
            content={this.props.content}
            value={this.props.data.vaFirstTimeUse}
            values={values}
            onChoiceMade={(index) => {
              this.props.customFormEdit("vaFirstTimeUse", values[index]);
              this.props.navigationContext.goNext(
                this.props.navigationsAway.Primary,
                true
              );
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqVaLoanBeforeView));
